import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatSelectModule, MatMenuModule, MatButtonModule, MatInputModule } from '@angular/material';
import { RootComponent } from './components/RootComponent';
import { DrawingsHolderService } from './drawings-holder.service';
import { PositionCalculatorService } from './position-calculator.service';
import { ComponentsList } from './ComponentsList';
import { ToolSwitcher } from './ToolSwitcher';
import { TextEditorComponent } from './ng-components/text-editor/text-editor.component';
import { DimensionsEditorComponent } from './ng-components/dimensions-editor/dimensions-editor.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ChangeObjectColorComponent } from './ng-components/change-object-color/change-object-color.component';
import * as Components from './components';
import { SetScaleModalComponent } from './ng-components/set-scale-modal/set-scale-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScreenShotService } from './screenShot.service';
import { SceneBoxCalculatorService } from './sceneBoxCalculator.service';
import { PrintService } from './print.service';
import { PlanBuilderService } from './plan-builder.service';
import { PostFactoryService } from 'app/services/proTools/post-factory.service';
import { EdgesControlsServcie } from './edges-controls.service';
import { DrawTitleBlockComponent } from './components/DrawTitleBlockComponent';
import { TitleBlockInfoComponent } from './ng-components/title-block-info/title-block-info.component';
import { TitleBlockComponent } from './ng-components/title-block/title-block.component';
import { EstimatorsService } from './estimators.service';
import { Step3ListComponent } from '../../step3-list/step3-list.component';
import { SaveProToolsActionsComponent } from '../../save-pro-tools-actions/save-pro-tools-actions.component';
import { PostEditorComponent } from './ng-components/post-editor/post-editor.component';
import { PicketEditorComponent } from './ng-components/picket-editor/picket-editor.component';
import { TitleBlockWarningComponent } from './ng-components/title-block-warning/title-block-warning.component.';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { PostTextGetterComponent } from './ng-components/post-text-getter/post-text-getter.component';

@NgModule({
  providers: [
    DrawingsHolderService,
    Components.DrawLineComponent,
    Components.CircleScaleComponent,
    Components.SelectComponent,
    Components.MoveObjectComponent,
    Components.DrawPolyLineComponent,
    Components.MovePolylineNodes,
    Components.PolyLineScaleComponent,
    Components.DrawArcComponent,
    Components.DrawCircleComponent,
    Components.CircleScaleComponent,
    Components.DrawRectangleComponent,
    Components.RectangleScaleComponent,
    Components.DrawAngleComponent,
    Components.DrawDimensionsComponent,
    Components.DrawTextComponent,
    Components.EditTextComponent,
    Components.EditDimensionsComponent,
    Components.DeleteObjectComponent,
    Components.CloneObjectComponent,
    Components.AddPostComponent,
    Components.MoveTextArrow,
    Components.AddPicketComponent,
    Components.AddCornerPostComponent,
    Components.EditPostComponent,
    Components.EditPicketComponent,
    RootComponent,
    PositionCalculatorService,
    ComponentsList,
    ToolSwitcher,
    ScreenShotService,
    SceneBoxCalculatorService,
    PrintService,
    PlanBuilderService,
    PostFactoryService,
    EdgesControlsServcie,
    DrawTitleBlockComponent,
    EstimatorsService,
    Step3ListComponent
  ],
  entryComponents: [
    TextEditorComponent,
    DimensionsEditorComponent,
    ChangeObjectColorComponent,
    SetScaleModalComponent,
    TitleBlockInfoComponent,
    TitleBlockComponent,
    SaveProToolsActionsComponent,
    PostEditorComponent,
    PostTextGetterComponent,
    PicketEditorComponent,
    TitleBlockWarningComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    ColorPickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [
    TextEditorComponent,
    DimensionsEditorComponent,
    ChangeObjectColorComponent,
    SetScaleModalComponent,
    TitleBlockInfoComponent,
    TitleBlockComponent,
    SaveProToolsActionsComponent,
    PostEditorComponent,
    PostTextGetterComponent,
    PicketEditorComponent,
    TitleBlockWarningComponent
  ],
  exports: [
    ChangeObjectColorComponent,
    SetScaleModalComponent,
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
export class ProToolsModule {
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/Module.ts